/**
 * Get content session from brightspot
 *
 */
import { gql } from '@apollo/client'
import { getIsLowBandwidth } from '../../hooks/useIsLowBandwidth'

const recipeQuery = (path) => {
  const imageSize = getIsLowBandwidth() ? 250 : 500
  return `
  {
    RecipePage(id: "${path}") {
      title
      description
      locale
      parentLocale
      contentId
      recipe
      creators {
        name
        title
        profilePhoto {
          custom(height: ${imageSize}, width: ${imageSize}) {
          image {
            src
            }
          }
        }
      }
      suggestedContent {
        objectTypeId
        locale
        parentLocale
        title
        description
        url
        contentUUID
          image {
          custom(height: ${imageSize}, width: ${imageSize} ) {
            image {
              src
            }
          }
        }
        creators {
          profilePhoto {
            custom(height: ${imageSize}, width: ${imageSize}) {
              image {
                src
                }
              }
          }
        }
      }
      videos {
        videoProvider {
          ... on YoutubeVideoProvider {
            providerType
            videoDuration
            videoId
          }
          ... on RootsTechBrightcoveVideoProvider {
            accountId
            playerId
            videoId
            providerType
          }
        }
      }
    }
  }
`
}

export const contentSessionGQLQuery = ({ path, model }) => {
  if (model === 'RecipePage') {
    return gql(recipeQuery(path))
  }
  const profilePhotoSize = getIsLowBandwidth() ? 160 : 320
  const imageSize = getIsLowBandwidth() ? 250 : 500

  return gql(`
    {
      ${model}(id: "${path}") {
        ${
          model === 'LiveSession'
            ? `duration
        variant
        date{
          timestamp
        }
        `
            : ''
        }
        title
        locale
        parentLocale
        description
        contentId
        creators {
          name
          title
          contentId,
          url
          profilePhoto {
            custom(height: ${profilePhotoSize}, width: ${profilePhotoSize}) {
              image {
                src
                }
              }
          }
        }
        suggestedContent {
          objectTypeId
          locale
          parentLocale
          title
          description
          url
          contentUUID
          date{
            timestamp
          }
          image {
          custom(height: ${imageSize}, width: ${imageSize} ) {
            image {
              src
            }
          }
        }
          creators {
            profilePhoto {
              custom(height: ${imageSize}, width: ${imageSize}) {
                image {
                  src
                  }
                }
            }
          }
        }
        ${
          model === 'LiveSession' || model === 'ClassSessionPage'
            ? `
        keywords
        classSyllabus {
          contentId
          href
          title
        }
        slideDeck {
          contentId
          href
          title
        }
        additionalExperiences {
          objectTypeId
          locale
          parentLocale
          title
          description
          url
          contentUUID
          image {
            custom(height: ${imageSize}, width: ${imageSize}) {
              image {
                src
                }
              }
          }
        }`
            : ''
        }
        videos {
          videoProvider {
            ... on YoutubeVideoProvider {
              providerType
              videoDuration
              videoId
            }
            ... on RootsTechBrightcoveVideoProvider {
              accountId
              playerId
              videoId
              providerType
            }
          }
        }
      }
    }
  `)
}

export const dummy = () => {}
